import "./application";
import '../apps/on_boarding/main';
import graph_client from '../utils/graphql/graph_client';
import { RedeemGiftCard } from '../utils/graphql/redeem-graph';
import { OnBoardingGoal } from '../utils/models/OnBoardingGoal';
import {RevenueCatWrapper} from "../utils/RevenueCatWrapper";
import '../apps/redeem/main';
import { i18n } from '../i18n';

const t = i18n.global.t;

// script.js
const digitInputs = document.querySelectorAll('.redeem-input');

digitInputs.forEach((input, index) => {
  input.addEventListener('input', (e) => {
    const { value } = e.target;
    if (value.length === 1) {
      if (index < digitInputs.length - 1) {
        digitInputs[index + 1].focus();
      }
    }
  });

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Backspace' && index > 0 && e.target.value.length === 0) {
      digitInputs[index - 1].focus();
    }
  });
});

const redeemButton = document.getElementById('redeemButton');
const clearButton = document.getElementById('clearButton');

function areAllInputsFilled() {
  return Array.from(digitInputs).every((input) => input.value.trim() !== '');
}

function clearAllInputs() {
  digitInputs.forEach((input) => (input.value = ''));
}

let queryString = window.location.search;

// Create a URLSearchParams object
let urlParams = new URLSearchParams(queryString);

// Get the value of a specific parameter, for example 'param1'
let paramValue = urlParams.get('code');
if (paramValue) {
  const combinedValue = paramValue.toUpperCase().split('')
  const inputs = Array.from(digitInputs);
  combinedValue.forEach((value, index) => {
    inputs[index].value = value;
  });
}

async function redeemGiftCard(giftCardId) {
  const isProOrProPlus = await RevenueCatWrapper.isProOrProPlus();
  if (isProOrProPlus) {
    alert(t('entrypoints.redeem.already_pro'));
    return;
  }
  graph_client.request(
    RedeemGiftCard,
    {
      input: {
        giftToken: giftCardId.toLowerCase(),
      },
    },
  ).then((data) => {
    if (data.redeemGiftCard) {
      alert(t('entrypoints.redeem.redeemed_successfully'));
      window.location.href = '/profile';
    } else {
      alert(t('entrypoints.redeem.gift_card_not_found'));
    }
  }).catch((error) => {
    if (error.response.errors && error.response.errors.length > 0) {
      alert(error.response.errors[0].message);
    } else {
      alert(t('entrypoints.redeem.unknown_error_contact_support'));
    }
  });
}

if (redeemButton) {
  redeemButton.addEventListener('click', async () => {
    if (areAllInputsFilled()) {
      const combinedValue = Array.from(digitInputs).map((input) => input.value.toUpperCase()).join('');
      if (window.user) {
        await redeemGiftCard(combinedValue);
      } else {
        window.onBoardingVue.launchFor(OnBoardingGoal.RedeemVoucher);
      }
    } else {
      alert(t('entrypoints.redeem.fill_in_all_fields'));
    }
  });
}

if (clearButton) {
  clearButton.addEventListener('click', () => {
    clearAllInputs();
  });
}
